import React from 'react';
import {WidgetConfiguration} from './widget-configuration';

export const resolveWidget = (
  configuration,
  metaWidgetId,
  key,
  heartRate,
  container = false
) => {
  let widget;
  if (WidgetConfiguration[metaWidgetId]) {
    widget = WidgetConfiguration[metaWidgetId].widget(
      configuration,
      heartRate,
      key
    );
  } else {
    widget = <div key={key}>configuration is missing</div>;
  }

  if (container) {
    return (
      <div
        style={{height: '100%'}}
        className={'fill-window'}
        id={'view_widget_container'}
      >
        {widget}
      </div>
    );
  } else {
    return widget;
  }
};

export function resourceUrl(candidate) {
  if (candidate.includes('pulsoid') || candidate.includes('localhost:9000')) {
    return candidate;
  } else {
    return 'https://pulsoid.net' + candidate;
  }
}

export const findActiveRange = (ranges, pulse) => {
  return ranges.find((range) => range.from <= pulse && range.to >= pulse);
};
export function findColorInRanges(ranges, pulse, defaultColor = 'transparent') {
  const currentRange = findActiveRange(ranges, pulse);

  if (currentRange?.color) {
    return currentRange.color;
  } else if (currentRange && !currentRange.color) {
    return 'transparent';
  } else if (ranges && ranges.length) {
    if (pulse < ranges[0]?.from) {
      return ranges[0]?.color;
    } else if (pulse > ranges[ranges.length - 1]?.to) {
      return ranges[ranges.length - 1]?.color;
    }
  }

  return defaultColor;
}

export class PulseSpeedStrategy {
  constructor() {
    this.stratagies = [];
  }

  add(from, to, time) {
    this.stratagies.push({from: from, to: to, time: time});
  }

  get(bpm) {
    for (var i = 0; i < this.stratagies.length; i++) {
      var s = this.stratagies[i];
      if (bpm >= s.from && bpm <= s.to) {
        return s.time;
      }
    }
    return null;
  }
}

// https://pulsoid.atlassian.net/browse/PLS-742?focusedCommentId=10180
export function resolveRangeWithFallback(ranges, pulse, fallback) {
  let previous;
  for (let i = 0; i < ranges.length; i++) {
    previous = ranges[i - 1];
    let range = ranges[i];
    if (range.from <= pulse && range.to >= pulse) {
      return range;
    } else if (range.from > pulse) {
      return previous ? previous : range;
    }
  }
  return fallback;
}
